<template>
  <div class="body">
    <center>
      <div class="box">
        <div>
          <div
            style="
              width: 336px;
              height: 465px;
              background: #4b81db;
              padding: 20px;
            "
          >
            <v-row style="background: #4b81db; padding-bottom: 15px">
              <div class="div1"></div>
              <h1 style="color: #ffffff">公告栏</h1>
              <br />
            </v-row>
            <div class="lt"></div>
            <marquee
              scrollamount="1"
              direction="up"
              onmouseover="this.stop()"
              onmouseout="this.start()"
              height="400px"
              width="296px"
              v-if="show"
            >
              <li v-for="(item, i) in bar1" :key="i">
                <span
                  @click="tochild(item)"
                  class="cursor"
                  style="color: #ffffff; font-size: 16px; text-decoration: none"
                  >{{ item.title }}</span
                >
              </li>
            </marquee>
          </div>
          <div
            style="
              width: 336px;
              min-height: 445px;
              padding: 15px;
              border-top: 20px solid #f2f2f2;
            "
          >
            <div style="display: flex; flex-direction: row">
              <div class="div1" style="background-color: #015293"></div>
              <h1>团体会员单位</h1>
            </div>
            <br />
            <hr />
            <div class="bar2" v-for="(item, i) in bar2" :key="'bar2-' + i">
              <br />
              <span @click="tootherchild(item)" class="cursor">{{
                item.title
              }}</span>
              <br />
            </div>
            <br />
            <div style="display: flex; flex-direction: row">
              <div class="div1" style="background-color: #015293"></div>
              <h1>特聘专家</h1>
            </div>
            <br />
            <hr />
            <div class="bar3" v-for="(item, i) in bar3" :key="'bar3-' + i">
              <br />
              <span @click="tootherchild(item)" class="cursor">{{
                item.title
              }}</span>
              <br />
            </div>
          </div>
        </div>
        <div style="padding: 20px; width: 610px; min-height: 1090px; border: 15px">
          <div style="display: flex">
            <div class="div1" style="background-color: #015293"></div>
            <h1>工作动态</h1>
          </div><span style="float:right;margin-top: -15px;" @click="gzdt" class="cursor">更多</span>
          <br />
          <hr />

          <div v-for="(item, i) in list1" :key="'listFirt-' + i">
            <div @click="tochild(item)" class="cursor">
              <div
                v-if="i < 1"
                style="
                  width: 570px;
                  font-size: 16px;
                  font-weight: bold;
                  line-height: 36px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ item.title }}
              </div>

              <div
                v-if="i < 1"
                style="
                  width: 570px;
                  font-size: 14px;
                  color: rgba(149, 149, 149, 1);
                "
              >
                {{ wb.substr(0, 80) }}...
                <span style="float: right; color: blue; font-size: 14px"
                  >[详情]</span
                >
              </div>
            </div>
          </div>
          <div
            class="list1"
            v-for="(item, i) in list1"
            :key="'list1-' + i"
            style="display: flex; justify-content: space-between"
          >
            <div v-if="i >= 1&& i<10">
              <li
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  width: 450px;
                  margin: 6px 0px;
                "
              >
                <span @click="tochild(item)" class="cursor">{{
                  item.title
                }}</span>
              </li>
            </div>
            <div v-if="i >= 1 && i<10">
              <span
                style="
                  float: right;
                  font-size: 14px;
                  color: rgba(149, 149, 149, 1);
                  margin: 6px 0px;
                "
                >{{ item.add_time }}</span
              >
            </div>
          </div>
          <br />

          <div style="display: flex">
            <div class="div1" style="background-color: #015293"></div>
            <h1>会展动态</h1>
          </div>
          <span style="float:right;margin-top: -15px;" @click="gzdt" class="cursor">更多</span>
          <br />
          <hr />
          <br />
          <div
            class="list2"
            v-for="(item, i) in list2"
            :key="'list2-' + i"
            style="display: flex; justify-content: space-between"
          >
            <li
            v-if="i<10"
              style="
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                width: 450px;
                margin: 6px 0px;
              "
            >
              <span @click="tochild(item)" class="cursor">{{
                item.title
              }}</span>
            </li>
            <span
            v-if="i<10"
              style="
                float: right;
                font-size: 14px;
                color: rgba(149, 149, 149, 1);
                margin: 6px 0px;
              "
              >{{ item.add_time }}</span
            >
          </div>
        </div>
        <div
          style="
            width: 224px;
            min-height: 1090px;
            background: #ffffff;
            padding: 20px;
          "
        >
          <div style="display: flex; flex-direction: row">
            <div class="div1" style="background-color: #015293"></div>
            <h1>团体会员</h1>
          </div>
          <br />
          <hr />
          <br />
          <div
            v-for="(item, i) in bar4"
            :key="'bar4-' + i"
            style="text-align: center"
          >
            <div v-html="item.content"></div>
            <p>{{ item.title }}</p>
          </div>
          <br />
          <div style="display: flex; flex-direction: row">
            <div class="div1" style="background-color: #015293"></div>
            <h1>合作伙伴</h1>
          </div>
          <br />
          <hr />
          <center>
            <br />
            <div v-for="(item, i) in bar5" :key="'bar5-' + i">
              <a :href="item.detail">
                <img
                  :src="domain + item.path"
                  width="184px"
                  height="71px"
                  style="border: 1px solid #e7e7e7; margin-bottom: 10px"
                />
              </a>
            </div>
            <br />
          </center>
        </div>
      </div>
      <div
        style="
          width: 1200px;
          min-height: 148px;
          background: #ffffff;
          border-top: 20px solid #f2f2f2;
          border-bottom: 20px solid #f2f2f2;
          padding: 15px;
        "
      >
        <div style="display: flex; flex-direction: row">
          <div class="div1" style="background-color: #015293"></div>
          <h1 style="text-align: left">友情链接</h1>
        </div>
        <br />
        <v-row>
          <div class="link" v-for="(item, i) in link" :key="'link-' + i">
            <a
              :href="item.detail"
              class="cursor"
              style="color: black; text-decoration: none"
              >{{ item.mark }}</a
            >
          </div>
        </v-row>
      </div>
    </center>
  </div>
</template>

<script>
export default {
  name: "Main",

  data() {
    return {
      show: false,
      bar1: [],
      bar2: [],
      bar3: [],
      bar4: [],
      bar5: [],
      list1: [],
      list2: [],
      link: [],
      domain: "http://api.hbsae.com",
      wb: "",
      reg: /<\/?.+?\/?>/g,
    };
  },
  created() {
    this.$emit("hbhead", 0);
    this.$axios.get("/index").then((Response) => {
      this.bar1 = Response.data.data.bar1;
      this.show = true;
      this.bar2 = Response.data.data.bar2;
      this.bar3 = Response.data.data.bar3;
      this.bar4 = Response.data.data.bar4;
      this.bar5 = Response.data.data.bar5;
      this.list1 = Response.data.data.list1;
      this.list2 = Response.data.data.list2;
      this.link = Response.data.data.link;
      this.wb = this.list1[0].content
        .replace(this.reg, "")
        .replace(/[&nbsp;]/g, "");
    });
  },
  methods: {
    gzdt(index) {
      this.$router.push('/gzdt');
    },
    tochild(data) {
      this.$router.push({
        name: "gzdt",
        params: {
          id: data.id,
        },
      });
    },
    tootherchild(data) {
      this.$router.push({
        path: "/tthydw",
        query: {
          id: data.id,
        },
      });
    },
  },
};
</script>
<style scoped>
.body {
  height: 100%;
  width: 100%;
  background-color: #f2f2f2;
}
marquee > li {
  color: #ffffff;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 10px 0px;
}
.cursor {
  cursor: pointer;
}

div {
  background-color: #ffffff;
  text-align: left;
}
.link > a {
  margin: 0px 20px;
}
.div1 {
  width: 3px;
  height: 15px;
  line-height: 50px;
  background: #ffffff;
  text-align: center;
  margin-top: 5px;
  margin-right: 5px;
}

.box {
  display: grid;
  grid-column-gap: 15px;
  grid-template-columns: 336px 610px 224px;
  align-content: center;
  justify-content: center;
  width: 1200px;
  background-color: #f2f2f2;
  padding-top: 20px;
}

h1 {
  width: 160px;
  height: 18px;
  font-size: 18px;
  font-weight: bold;
  color: rgba(1, 81, 147, 1);
}

hr {
  border: 0.5px solid gray;
  background-color: #bcbcbc;
}
.lt {
  background-color: #366dc9;
  height: 15px;
  width: 296px;
  position: absolute;
  z-index: 1;
  opacity: 0.5;
}
</style>